import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#DB4435",
    },
    secondary: {
      main: "#daaaaa",
    },
  },
});
